import { createApp } from 'vue'
import SupportSelector from './SupportSelector'

const el = '.kb-component--support-selector'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SupportSelectorDOM) => {
            const props = {
                stafetId: SupportSelectorDOM.dataset.stafetId,
                labels: SupportSelectorDOM.dataset.labels
                    ? JSON.parse(SupportSelectorDOM.dataset.labels)
                    : {}
            }
            const component = createApp(SupportSelector, props).use(Store)
            component.mount(SupportSelectorDOM)
        })
    }
}
